<template>
    <div class="d-flex justify-content-center">
        <div class="main-content col-md-8 bg-white">
            <div class="heading-section my-4 col-md-10 offset-md-1 row align-items-center">
                <h4 class="text-left font-bold text-normal mt-3 col-md-4">
                    OUR ESTATES
                </h4>
                <span class="d-block text-left col text-normal text-sm">
                    will be equipped with state-of-the-art amenities like Recreation Centre, Supermarket, Park, Internet Service and much more.
                </span>
            </div>
            <div class="body-section col-12">
                <div class="row mx-0 justify-content-between">
                    <router-link :to="`/our-houses/${house.slug}`" class="col-md-5 px-0 mb-3"
                        v-for="house in housesList" :key="house.id">
                        <div class="overlay"></div>
                        <img class="img-fluid img-content" :src="house.list_photo" :alt="house.title.rendered">
                        <div class="text-description d-flex flex-column justify-content-center">
                            <div class="button-container">
                                <button class="btn-lg btn-normal">Explore</button>
                            </div>
                            <div class="text-content mt-3">
                                <span class="text-sm d-block mb-2">{{ house.title.rendered }}</span>
                                <span class="text-sm d-block">- Title :  {{ house.access_title || 'C OF O'}}</span>
                            </div>
                        </div>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Houses',
    computed: {
        housesList() {
            return this.$store.state.houses
        },
    },
}
</script>

<style scoped>
.main-content {
    padding: 15px;
}
@media (min-width: 1200px) {
    .main-content {
        padding: 25px 60px;
    }
}
@media (min-width: 992px) {
    .main-content {
        padding: 20px 40px;
        border-radius: 20px;
        box-shadow: 10px 10px 6px #0000000D;
    }
}
.img-content {
    border-radius: 7px;
}
.overlay {
    border-radius: 7px;
    background-color: #6E2169A2;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}
.text-sm {
    font-size: 11px;
}
.body-section {
    margin: 30px 0 50px 0;
    padding: 0 50px
}
.download-btn {
    padding-left: 30px;
    padding-right: 30px;
    color: #fff!important;
    text-transform: capitalize;
    margin-top: 30px;
}
.text-description {
    color: #fff;
    position: absolute;
    width: 100%;
    text-align: center;
    height: 100%;
    top: 0;
    left: 0;
}
</style>